/* DSD p11dz347 - Social Surface State Governance
   Operating Manual only. Governance metadata only. No Firebase/realtime/backend activation.
*/
(function(){
  var routes = {"/pages/notifications": "canonical_surface", "/pages/messages": "canonical_surface", "/pages/stories": "canonical_surface", "/pages/persistence-registry": "canonical_surface"};
  var path = window.location.pathname || "";
  var classification = routes[path] || null;
  window.DSDSocialSurfaceStateGovernance346 = {
    version: "p11dz347",
    path: path,
    classification: classification,
    authority: "DSD Operating Manual V25",
    firebaseReads: false,
    firebaseWrites: false,
    realtime: false,
    backendActivation: false
  };
  if(classification){
    document.documentElement.setAttribute("data-dsd-social-route-classification", classification);
  }
})();